<div>
  <a
    class="skip-main"
    [routerLink]="[]"
    (click)="skipToMainContent()"
    attr.aria-label="Skip to content"
    >Skip to main content</a
  >
</div>
